export const scrollOptions = {
  duration: 1500,
  delay: 100,
  smooth: true
};

export interface AdditionalSearchParams {
  vehicleIds: string[];
  namesManufacturer: string[];
  namesModel: string[];
  codeUsage: string[];
  codeBody: string[];
  locations: string[];
  queryString: string;
}
